module.exports = __webpack_public_path__ + "static/equinoxthumb-3e264d656f0b1ea956d3879ca04eb67f.jpg";